import { Address } from '@dreryk/address-common-api';
import { EmailAddress } from '@dreryk/email-address-common-api';
import { PhoneNumber } from '@dreryk/phone-number-common-api';
import { Regon } from '@dreryk/regon-common-api';
import { TaxIdentifier } from '@dreryk/tax-identifier-common-api';

import { addressFormatter, phoneNumberFormatter, useTranslate } from '@dreryk/react-common';
import {
   appendTestableElementAttributes,
   LabeledText,
   StrongText,
   StyledFlex,
   TestableComponentProps,
   Text,
   TextSeparator,
   TextSeparatorType,
} from '@dreryk/react-components';

import { healthcareOrganizationTranslationKeys } from '../../translations';

export type HealthcareBasicData = {
   readonly id: number;
   readonly emailAddress?: EmailAddress;
   readonly name: string;
   readonly phoneNumber?: PhoneNumber;
   readonly address?: Address;
};

type HealthcareBasicDataProps = TestableComponentProps &
   HealthcareBasicData & {
      readonly regon?: Regon;
      readonly taxIdentifier?: TaxIdentifier;
      readonly withoutIdentifiers?: boolean;
   };

export const HealthcareBasicDataPanel = (props: HealthcareBasicDataProps): JSX.Element => {
   const translate = useTranslate();

   return (
      <StyledFlex direction={'column'} gap={'8px'} {...appendTestableElementAttributes(props.testId)}>
         <StrongText testId={'name'}>{props.name}</StrongText>
         <Text testId={'address'}>{addressFormatter(props.address)}</Text>
         <TextSeparator separator={TextSeparatorType.COMMA_SPACE}>
            {props.phoneNumber ? <Text testId={'phone'}>{phoneNumberFormatter(props.phoneNumber)}</Text> : null}
            {props.emailAddress ? <Text testId={'email'}>{props.emailAddress.asString()}</Text> : null}
         </TextSeparator>
         {!props.withoutIdentifiers && (
            <TextSeparator separator={TextSeparatorType.COMMA_SPACE}>
               {props.regon ? (
                  <LabeledText
                     before={translate(healthcareOrganizationTranslationKeys.regon)}
                     separator={TextSeparatorType.COLON_SPACE}
                  >
                     <Text testId={'regon'}>{props.regon.asString()}</Text>
                  </LabeledText>
               ) : null}
               {props.taxIdentifier ? (
                  <LabeledText
                     before={translate(healthcareOrganizationTranslationKeys.taxIdentifier)}
                     separator={TextSeparatorType.COLON_SPACE}
                  >
                     <Text testId={'taxIdentifier'}>{props.taxIdentifier.asString()}</Text>
                  </LabeledText>
               ) : null}
            </TextSeparator>
         )}
      </StyledFlex>
   );
};
